import { css } from 'styled-components';

export const HoverState = css`
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }

  &:active {
    opacity: 0.9;
  }
`;

export const ActiveState = css`
  transition: opacity 0.3s;

  &:active {
    opacity: 0.9;
  }
`;
